import type { AppProps } from '@atlassian/jira-servicedesk-knowledge-services/src/types';

export const INITIALIZE_APP_PROPS = 'state.actions.app.INITIALIZE_APP_PROPS' as const;

export const UPDATE_CATEGORY_SIDEBAR_LABEL =
	'state.actions.app.UPDATE_CATEGORY_SIDEBAR_LABEL' as const;

export type InitializeAppPropsAction = {
	type: typeof INITIALIZE_APP_PROPS;
	payload: AppProps;
};

export const initializeAppProps = (payload: AppProps): InitializeAppPropsAction => ({
	type: INITIALIZE_APP_PROPS,
	payload,
});

export type UpdateCategorySidebarLabelAction = {
	type: typeof UPDATE_CATEGORY_SIDEBAR_LABEL;
	payload: string;
};

export const updateCategorySidebarLabel = (payload: string): UpdateCategorySidebarLabelAction => ({
	type: UPDATE_CATEGORY_SIDEBAR_LABEL,
	payload,
});
